module.exports = __webpack_public_path__ + "img/question_icon.b426da8b.png";